import { useSWR } from '@tiger/swr';
import security from 'stores/security';
import API from 'utils/API';

export type BusinessType = 'ACH_WITHDRAW' | 'ACH_DEPOSIT' | 'WIRE_WITHDRAW' | 'WIRE_DEPOSIT' | 'POSITION_TRANSFER_IN';

// 获取当前账户出入金是否是白名单
export function useBlackWhiteStatus(businessType: BusinessType) {
    return useSWR<{ isBlack: boolean; isWhite: boolean }>(
        security.isAccountOpened
            ? {
                  url: API.TRADE.funding.getBlackHouseEnable(),
                  params: {
                      accountId: security.currentAccountId,
                      businessType,
                      customerId: security.currentCustomerId
                  }
              }
            : null,
        {
            dataChain: ({ data }) => data
        }
    );
}
